"use strict";

exports.__esModule = true;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    render: function render() {
        var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('transition', { attrs: { "name": "vui-fade" } }, [_c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.visible, expression: "visible" }], staticClass: "vui-modal", class: _vm.className, style: _vm.style, on: { "touchmove": function touchmove($event) {
                    $event.preventDefault();$event.stopPropagation();
                }, "click": function click($event) {
                    _vm.$emit('click', $event);
                } } })]);
    },

    name: 'modal', // eslint-disable-line

    props: {
        visible: { type: Boolean, default: false },
        zIndex: { type: Number, default: 0 },
        className: { type: String, default: '' },
        customStyle: { type: Object, default: function _default() {
                return undefined;
            } }
    },

    computed: {
        style: function style() {
            return (0, _extends3.default)({
                zIndex: this.zIndex
            }, this.customStyle);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tuniu/dpl-vui/lib/mixins/popup/Modal.js
// module id = 484
// module chunks = 22